import { generateSearchUrl } from '@services/MarppleShop/features/Search/const/url.ts';
import {
  makePopupScreenNavigate,
  makeRankScreenNavigate,
  makeSearchScreenNavigate,
  makeUtilScreenNavigate,
} from '@services/MarppleShop/shared/app/navigate.ts';
import { isApp, mpsPostMessage } from '@services/MarppleShop/shared/app/util.ts';
import axios from 'axios';
import { CustomEventWithDetail, CustomEventWithoutDetail, html, on, View } from 'rune-ts';
import { generateProductListUrl } from '../../../../features/ProductList/util';
import { Locals } from '../../../../shared/type/locals';
import { staticTypo, typo } from '../../../../shared/typography/typo';
import { ButtonText } from '../../atoms/ButtonText/ButtonText';
import { CloseIcon } from '../../atoms/Icon';
import { AutoCompleteSearchInput, NotEmptySubmitEvent } from '../SearchModule/view/AutoCompleteSearchInput';
import limited_klass from './LimitedEditionBanner.module.scss';
import klass from './ShopProductCategory.module.scss';
import { getResizedImage100WebpUrl } from '@services/MarppleShop/shared/util/getResizedImageUrl.ts';
import { dataStr } from '@services/MarppleShop/shared/util/dataStr';
import { font } from '@services/MarppleShop/shared/typography';
import { postSearchLogApi } from '@services/MarppleShop/features/Search/api';

type CateListViewData = {
  id?: number;
  label: string;
};

type CateItemViewData = {
  id?: number;
  cate_list_id?: number;
  label: string;
};

export type ShopProductCategoryData = {
  cate_lists: CateListViewData[];
  cate_items: CateItemViewData[];
  placeholder?: string;
};

export class ShopProductCategoryCloseClicked extends CustomEventWithoutDetail {}

export class ShopProductCategoryChangeEvent extends CustomEventWithDetail<{
  cate_list_id?: number;
  cate_item_id?: number;
}> {}

class CateListView extends ButtonText<CateListViewData> {
  constructor(data: CateListViewData, option: { is_active?: boolean } = {}) {
    super(data, {
      ...option,
      container_klass: `${klass.cate_view} ${klass.cate_list}`,
      active_klass: klass.cate_list_active,
      prevent_default_click: true,
    });
  }
}

class CateItemView extends ButtonText<CateItemViewData> {
  constructor(data: CateItemViewData, option: { is_active?: boolean } = {}) {
    super(data, {
      ...option,
      container_klass: `${klass.cate_view} ${klass.cate_item}`,
      data_id: data.cate_list_id,
      prevent_default_click: true,
      is_active: !!data.cate_list_id && !data.id,
    });
  }
}

class LimitedEditionView extends View {
  override template() {
    return html`<a class="${limited_klass.container}" href="${generateProductListUrl({ is_limited: true })}">
      <div class="${limited_klass.text_container}">
        <span class="${limited_klass.text} ${staticTypo('bebas_20_bold')}">LIMITED</span>
        <span class="${limited_klass.text} ${staticTypo('bebas_20_bold')}">EDITION</span>
      </div>
      <div class="${limited_klass.image_container}">
        <img
          class=${limited_klass.background_image}
          src="//s3.marpple.co/files/u_2232571/2024/5/original/3b6b77967541bf62f26ef2a5d3ca0e048b8ac5701.png"
        />
        <img
          class="${limited_klass.clover_image}"
          src="//s3.marpple.co/files/u_2232571/2024/5/original/f7c746797a65d8ad4aba6afd232ce8836f4dcb931.png"
        />
      </div>
    </a> `;
  }
}

export class ShopProductCategory extends View<ShopProductCategoryData> {
  AutoCompleteSearchInputView: AutoCompleteSearchInput;

  constructor(
    data: ShopProductCategoryData,
    public option: {
      webviewapp?: Locals['webviewapp'];
      has_bottom_tab_bar?: boolean;

      // 활성화 할 대카테고리
      // cate_list_id?: number;

      // 활성화 할 중카테고리
      // cate_item_id?: number;
    } = {},
  ) {
    super(data, option);

    this.AutoCompleteSearchInputView = new AutoCompleteSearchInput({
      highlight: 'stroke',
      placeholder: this.data.placeholder,
      container_klass: klass.search_input,
      debounce_ms: 200,
      placeholder_gray50: true,
    });
  }

  static quick_menus = () => [
    {
      title_mo: ET('mps2::breadcrumbs::creator_ranking'),
      image: getResizedImage100WebpUrl(
        '//s3.marpple.co/files/u_29089/2025/5/original/4cbecba2f69d3bb8ba6583d83e4c4f7f94524c621.png',
        300,
      ),
      navigate: makeRankScreenNavigate(`/${ET.lang}/@/creator/ranking/realtime`),
      href: `/${ET.lang}/@/creator/ranking/realtime`,
      target: '_self',
    },
    {
      title_mo: ET('mps2::main::quick_menus::popup_store_mo'),
      image: getResizedImage100WebpUrl(
        '//s3.marpple.co/files/u_29089/2025/5/original/0b87814c9820b3e90e107ff638eb94699754015a2.png',
        300,
      ),
      navigate: makePopupScreenNavigate(`/${T.lang}/@/popup-store`),
      href: `/${T.lang}/@/popup-store`,
      target: '_self',
    },
    {
      title_mo: ET('mps2::main::quick_menus::curation'),
      image: getResizedImage100WebpUrl(
        '//s3.marpple.co/files/u_29089/2025/5/original/4fbf796653f5ac4f72ff6162c6d65934fac327403.png',
        300,
      ),
      navigate: makePopupScreenNavigate(`/${ET.lang}/@/curations`),
      href: `/${T.lang}/@/curations`,
      target: '_self',
    },
    {
      title_mo: ET('mps2::main::quick_menus::photo_review_mo'),
      image: getResizedImage100WebpUrl(
        '//s3.marpple.co/files/u_29089/2025/5/original/1b524038e66a319be51d1c80edd8fbdecfbba2594.png',
        300,
      ),
      navigate: makeUtilScreenNavigate(`/${T.lang}/@/communities`),
      href: `/${T.lang}/@/communities`,
      target: '_self',
    },
  ];

  override template() {
    const [first_cate_item, ...rest_cate_items] = this.data.cate_items;
    const webviewapp = this.option.webviewapp;

    return html`<div
      ${webviewapp?.is_tab_screen ? html`style="padding-bottom: ${62 + webviewapp.safe_area_bottom}px"` : ''}
      class="${klass.shop_product_category} ${typo('14_medium')}"
    >
      <div class="${klass.search}">
        ${this.AutoCompleteSearchInputView}
        <span class="${klass.close}">${CloseIcon()}</span>
      </div>
      <div class="${klass.quick_menus}">
        ${ShopProductCategory.quick_menus().map(({ title_mo, image, navigate, href, target }) => {
          return html`<a
            class="${klass.quick_menu} "
            ${navigate ? html`data-post-message="${dataStr(navigate)}"` : ''}
            href="${html.preventEscape(href)}"
            target="${target}"
          >
            <div class="${klass.image_container}">
              <img class="${klass.image}" src="${image}" alt="" />
            </div>
            <div class="${klass.title} ${font('12_medium')}">${title_mo}</div>
          </a>`;
        })}
      </div>
      <div class="${klass.cate_slider}">
        <div class="${klass.cate_container} ${klass.cate_list_container}">
          ${this.data.cate_lists.map((cate_list) => new CateListView(cate_list))}
        </div>
        <div class="${klass.cate_container} ${klass.cate_item_container}">
          ${first_cate_item ? new CateItemView(first_cate_item) : ''} ${new LimitedEditionView({})}
          ${rest_cate_items.map((cate_item) => new CateItemView(cate_item))}
        </div>
      </div>
    </div>`;
  }

  // 검색어 최근 검색어에 추가하고, 결과로 이동
  private async saveRecentSearch(search: string) {
    // 최근 검색어 저장
    await axios.post(`/${ET.lang}/@api/keywords/history`, null, {
      params: { q: search },
    });
  }

  // 검색어 최근 검색어에 추가하고, 결과로 이동
  private async confirmSearch(search: string) {
    const url = generateSearchUrl(search);
    this.AutoCompleteSearchInputView.setInputValue(search);
    await this.saveRecentSearch(search);

    if (isApp()) {
      mpsPostMessage(makeSearchScreenNavigate(url));
    } else {
      location.href = url;
    }
  }

  @on('click', `.${klass.close}`)
  onClickClose() {
    this.dispatchEvent(ShopProductCategoryCloseClicked, {
      bubbles: true,
    });
  }

  override onRender() {
    let activeCateListView: CateListView | undefined;
    const cate_list_map = new Map<string, CateListView>();

    const cate_item_map = new Map<number | undefined, CateItemView>();

    const cate_slider_el = this.element().querySelector(`.${klass.cate_slider}`) as HTMLElement;

    // 활성화 된 cate_item 변경
    const onCateListChange = (view: CateListView) => {
      if (activeCateListView) {
        activeCateListView.deactivate();
      }
      view.activate();
      activeCateListView = view;

      const cate_list_el = view.element();
      const cate_list_rect = cate_list_el.getBoundingClientRect();
      const slider_rect = cate_slider_el.getBoundingClientRect();

      // 활성화할 cate_list 가 윗부분에서 가려질 때
      if (cate_list_rect.top < slider_rect.top) {
        cate_list_el.scrollIntoView({ block: 'start' });
        // 활성화할 cate_list 가 아래 부분에서 가려질 때
      } else if (cate_list_rect.bottom > slider_rect.bottom) {
        cate_list_el.scrollIntoView({ block: 'end' });
      }
    };

    // 현재 보여지는 cate_item 컨테이너에서 가장 상위의 cate_item 이 변경될 때 실행하는 함수
    const onFirstCateItemChanged = (el: HTMLElement) => {
      const cate_list_id = el.dataset.id ?? 'undefined';
      const cateListViewToFocus = cate_list_map.get(cate_list_id);
      if (!cateListViewToFocus) {
        throw new Error();
      }
      onCateListChange(cateListViewToFocus);
    };

    // cate item이 스크롤될 때 가장 상단에 있는 cate item을 감시
    // cate item이 속한 cate list의 활성화 상태를 변경해준다.
    const cateItemObserver = createCateItemObserver({
      container_el: cate_slider_el,
      onFirstCateItemChanged: (entry) => onFirstCateItemChanged(entry.target as HTMLElement),
    });

    // create CateItemView map
    this.subViews(CateItemView).forEach((view) => {
      const { cate_list_id } = view.data;
      if (!cate_item_map.has(cate_list_id)) {
        cate_item_map.set(cate_list_id, view);
      }
      cateItemObserver.observe(view.element());
    });

    // create CateListView map
    this.subViews(CateListView).forEach((view) => {
      const { id } = view.data;
      cate_list_map.set((id ?? 'undefined').toString(), view);
    });

    // 초기 활성화 카테고리 설정
    // this.subViews(CateItemView).forEach((cate_item_view) => {
    //   const { cate_list_id, id } = cate_item_view.data;
    //
    //   if (cate_list_id === this.option.cate_list_id && id === this.option.cate_item_id) {
    //     const cate_list_view = cate_list_map.get((cate_list_id ?? 'undefined').toString());
    //     if (!cate_list_view) {
    //       return;
    //     }
    //     activeCateListView = cate_list_view;
    //     activeCateListView.activate();
    //     activeCateListView.element().scrollIntoView({ block: 'start' });
    //
    //     activeCateItemView = cate_item_view;
    //     cate_item_view.activate();
    //     activeCateItemView.element().scrollIntoView({ block: 'start' });
    //   }
    // });

    this.delegate(NotEmptySubmitEvent, AutoCompleteSearchInput, (e) => {
      const search = e.detail;
      if (search) {
        postSearchLogApi({ search, is_popular_search_word: false });
        return this.confirmSearch(search);
      }
    });

    this.delegate('click', CateListView, function onCateListClick(_e, view) {
      const cate_item_view = cate_item_map.get(view.data.id);
      if (!cate_item_view) {
        throw new Error();
      }
      const cate_item_el = cate_item_view.element();
      cate_item_el.scrollIntoView({
        behavior: 'smooth',
      });
    });

    this.delegate('click', CateItemView, function onCateItemClick(_e, view) {
      // if (activeCateItemView) {
      //   activeCateItemView.deactivate();
      // }
      // view.activate();
      // activeCateItemView = view;
      //
      this.dispatchEvent(ShopProductCategoryChangeEvent, {
        bubbles: true,
        detail: {
          cate_list_id: view.data.cate_list_id,
          cate_item_id: view.data.id,
        },
      });
    });
  }
}

const createCateItemObserver = ({
  container_el,
  onFirstCateItemChanged,
}: {
  container_el: HTMLElement;
  onFirstCateItemChanged: (entry: IntersectionObserverEntry) => void;
}): IntersectionObserver => {
  return new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }
        const boundingRect = entry.boundingClientRect;
        const intersectionRect = entry.intersectionRect;
        if (boundingRect.top < intersectionRect.top) {
          onFirstCateItemChanged(entry);
        }
      });
    },
    {
      threshold: [0.1, 0.9],
      root: container_el,
      rootMargin: '-10px',
    },
  );
};
